import React from 'react';
import { DailyWagArticleCommentForm } from './components/DailyWagArticleCommentForm';
import { DailyWagArticleCommentVirtualList } from './components/DailyWagArticleCommentVirtualList';
import { Flex } from '../../../../components/Flex';
import { Typography } from '../../../../components/Typography';
import { ArrowDownIcon } from '../../../../icons/ArrowDownIcon';
import { useGetDailyWagBlogArticleComments } from '../../../../hooks/api/useGetDailyWagBlogArticleComments';
import { CamelizedArticleResponse } from '../../../../types/api';
import { Box } from '../../../../wag-react/next-components/box';
import { Divider } from '../../../../wag-react/core-components/divider';
import { Button } from '../../../../wag-react/next-components/button';
export type DailyWagArticleCommentSectionProps = CamelizedArticleResponse['commentList'] & {
  slug: string;
};
export const DailyWagArticleCommentSection = ({
  items: initialComments,
  hasNextPage: initialHasNextPage,
  totalCount,
  slug
}: DailyWagArticleCommentSectionProps) => {
  const {
    data: comments,
    setData: setComments,
    isLoading,
    hasNextPage,
    getNextPage
  } = useGetDailyWagBlogArticleComments({
    initialComments,
    initialHasNextPage,
    slug
  });
  return <Box data-sentry-element="Box" data-sentry-component="DailyWagArticleCommentSection" data-sentry-source-file="index.tsx">
      <Divider data-sentry-element="Divider" data-sentry-source-file="index.tsx" />
      <Typography variant="h2" fontSize="26px" color="#474747" my="30px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {`Comments (${totalCount})`}
      </Typography>
      <DailyWagArticleCommentVirtualList value={comments} data-sentry-element="DailyWagArticleCommentVirtualList" data-sentry-source-file="index.tsx">
        {hasNextPage && <Button fontFamily="muliBold" fontSize="20px" my="16px" disabled={isLoading} onClick={() => getNextPage()}>
            <Flex alignItems="baseline" gridGap="8px">
              Load more comments
              <ArrowDownIcon fontSize="12px" {...isLoading && {
            color: 'wagGray'
          }} />
            </Flex>
          </Button>}
      </DailyWagArticleCommentVirtualList>

      <Box my="64px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Typography variant="h3" fontSize="22px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          Leave a comment
        </Typography>
        <DailyWagArticleCommentForm slug={slug} onSubmitted={comment => {
        /**
         * For UX purposes, we need to append the new comment on
         * the local state of comments so that it gives the user
         * a fast feedback on the event
         */
        setComments(prevComments => [comment, ...prevComments]);
      }} data-sentry-element="DailyWagArticleCommentForm" data-sentry-source-file="index.tsx" />
      </Box>
    </Box>;
};